/**
 * Copyright © 2026 Adnuntius AS.
 */
import {Component} from '@angular/core';

import template from './welcome-data-page.component.html';
import {AppSharedModule} from '../common/app-shared.module';

@Component({
  standalone: true,
  imports: [AppSharedModule],
  selector: 'adn-welcome-data-page',
  template
})
export class WelcomeDataPageComponent {
}
